import React, { ReactNode } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TitledDialogProps = {
    open: boolean;
    isContentChanged: () => boolean;
    hide: () => void;
    onExited?: () => void;
    title: string | ReactNode;
    children: ReactNode;
    actions?: ReactNode;
};

const TitledDialog: React.FC<TitledDialogProps> = ({
    open,
    isContentChanged,
    hide,
    onExited,
    title,
    children,
    actions,
}) => {
    const { formatMessage } = useIntl();

    const handleClose = () => {
        if (!isContentChanged() || confirm(formatMessage({ id: "confirm_dialog_close" }))) hide();
    };
    return (
        <Dialog
            open={open}
            maxWidth="sm"
            fullWidth
            onClose={handleClose}
            onTransitionExited={onExited}
            onClick={(event) => event.stopPropagation()}
        >
            <DialogTitle>
                {typeof title === "string" ? <FormattedMessage id={title} /> : title}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <FontAwesomeIcon icon={faClose} />
                </IconButton>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            {actions && <DialogActions>{actions}</DialogActions>}
        </Dialog>
    );
};

export default TitledDialog;
